document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});
$(document).ready(function () {
    msie_version();
    landing_section_height();

    // code for wow initialize
    wow = new WOW({
        mobile: false
    });
    wow.init();

    // code for new more
    if ($('.news-more').length) {
        $('.btn-share-icon').on('click', function () {
            $(this).parents('.news-teaser').parent().siblings().find('.news-more').removeClass('news-share--open');
            $(this).parent().toggleClass('news-share--open');
        });
    }
    // Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
        nav_height();
    });
    $('.nav-arrow').on('click', function () {
        $(this).parent().siblings('li.has-sub-menu').removeClass('sub--open').find('ul').slideUp();
        $(this).parent().toggleClass('sub--open').find('ul').first().slideToggle();
    });
    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 1000);
        return false;
    });
    // Search Text Toggle
    $('.search-btn').click(function () {
        $('.navigation').toggleClass('search-show');
    });
    //landing-slider-init
    var landingSlider = $('.landing-slider-init');
    if (landingSlider.length) {
        if (landingSlider.find('.landing-slide').length > 1) {
            landingSlider.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                loop: true,
                autoplay: true,
                onInitialize: function () {
                    if (landingSlider.find('.landing-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            landingSlider.show();
        }
    }
    //testimonial carousel
    var testimonialSlider = $('.testimonial-slider-init');
    if (testimonialSlider.length) {
        if (testimonialSlider.find('.testimonial-slide').length > 1) {
            testimonialSlider.owlCarousel({
                items: 1,
                nav: true,
                dots: false,
                loop: true,
                autoHeight: true,
                autoplay: true,
                onInitialize: function () {
                    if (testimonialSlider.find('.testimonial-slide').length === 1) {
                        this.settings.loop = false;
                        this.settings.nav = false;
                    }
                }
            });
        } else {
            testimonialSlider.show();
        }
    }
    //client carousel
    var clientSlider = $('.client-carousel');
    if (clientSlider.length) {
        if (clientSlider.find('.client-slide').length > 1) {
            clientSlider.owlCarousel({
                navigation: true, // Show next and prev buttons
                loop: true,
                nav: true,
                dots: false,
                autoplay: true,
                autoplayTimeout: 2000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 2
                    },
                    575: {
                        items: 4
                    },
                    991: {
                        items: 6
                    }
                }
            });
        } else {
            clientSlider.show();
        }
    }
    //gallery-slider
    var gallerySlider = $('.gallery-slider');
    if (gallerySlider.length) {
        if (gallerySlider.find('.gallery-slide').length > 1) {
            gallerySlider.owlCarousel({
                nav: true,
                items: 1,
                dots: false,
                autoHeight: true,
            });
        } else {
            gallerySlider.show();
        }
    }
    //ProjectSlider
    var ProjectSlider = $('.project-slider');
    if (ProjectSlider.length) {
        if (ProjectSlider.find('.project-slide').length > 1) {
            ProjectSlider.owlCarousel({
                nav: true,
                dots: false,
                loop: true,
                pagination: false,
                items: 3,
                margin: 40,
                slideSpeed: 700,
                paginationSpeed: 700,
                rewindSpeed: 700,
                responsive: {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 2
                    },
                    992: {
                        items: 3
                    }
                }
            });
        } else {
            ProjectSlider.show();
        }
    }

    // Owl-carosel with fancybox
    $(ProjectSlider).fancybox({
        selector: ".owl-item:not(.cloned) [data-fancybox='project-gallery']",
        backFocus: false,
        hash: false,
        thumbs: {
            autoStart: true
        }
    });
    //postSlider
    var postSlider = $('.related-post-slider');
    if (postSlider.length) {
        if (postSlider.find('.related-post-slide').length > 1) {
            postSlider.owlCarousel({
                nav: true,
                dots: false,
                margin: 20,
                autoplay: true,
                loop: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 2
                    },
                    768: {
                        items: 3
                    },
                    992: {
                        items: 4
                    }
                }
            });
        } else {
            postSlider.show();
        }
    }
    if ($('.tabs').length) {
        /*Tab Element*/
        $(".tab_content").hide();
        $(".tab_content:first").show();
        /* if in tab mode */
        $("ul.tabs li").click(function () {
            $(".tab_content").hide();
            var activeTab = $(this).attr("rel");
            $("#" + activeTab).fadeIn();

            $("ul.tabs li").removeClass("active");
            $(this).addClass("active");
            $(".tab_drawer_heading").removeClass("d_active");
            $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
        });
        /* if in drawer mode */
        $(".tab_drawer_heading").click(function () {
            $(".tab_content").hide();
            var d_activeTab = $(this).attr("rel");
            $("#" + d_activeTab).fadeIn();
            $(".tab_drawer_heading").removeClass("d_active");
            $(this).addClass("d_active");
            $("ul.tabs li").removeClass("active");
            $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
            scrollVal = $(this).parents('.tab_container').offset().top - header_height();
            $("html, body").animate({ scrollTop: scrollVal }, 1000);
        });
        /* Extra class "tab_last" to add border to right side of last tab */
        $('ul.tabs li').last().addClass("tab_last");
    }
    //Light Box
    if ($('.lightbox').length) {
        $('.lightbox').fancybox();
    }
    // code for counter initialize
    if ($('.counter-blocks').length) {
        var count_scroll = $('.counter-blocks').offset().top;
        if (count_scroll < win_height()) {
            $('.animation-counter').each(function () {
                init_odometer(this);
            });
        }
    }
    // code for circular-counter
    if ($('.circular-progressbar').length) {
        var count_flow = $('.circular-progressbar').offset().top;
        if (count_flow < win_height()) {
            $('.circular-progressbar').each(function () {
                circle_progress_bar(this);
            });
        }
    }
    if ($('#marketing').length) {
        Highcharts.setOptions({
            colors: ['#514cd1', '#9292f7', '#ffb30a']
        });
        Highcharts.chart('marketing', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                backgroundColor: null,
                plotShadow: false,
                type: 'pie'
            },
            credits: {
                enabled: false
            },
            title: {
                text: null
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: false,
                    }
                }
            },
            series: [{
                name: 'Strateries',
                data: [{
                    y: 7.9
                }, {
                    y: 1.1
                }, {
                    y: 1.0
                }]
            }]
        });
    }
});
$(window).resize(function () {
    setTimeout(function () {
        landing_section_height();
    }, 200);
    nav_height();
    isotope_masonry();
});
$(window).on('load', function () {
    //Preloader JS code
    setTimeout(remove_loader, 700);
    /*isotope_masonry Function*/
    isotope_masonry();
    if ($('.sorting-btn').length) {
        $('.date-name').on('click', function () {
            $(this).toggleClass("on");
            var type = $(this).attr('data-sort-value');
            /* convert it to a boolean */
            var isType = (type === 'dateby');
            var newType = (isType) ? 'filename' : 'dateby';
            /* pass it to isotope */
            $NewsGrid.isotope({
                sortBy: newType
            });
            /* Add Types */
            $(this).attr('data-sort-value', newType);
            /* Add type in Asc and Desc */
            $('.asc-desc').attr('data-sort-value', newType);
        });
        $('.asc-desc').on('click', function () {
            var sortValue = $(this).attr('data-sort-value');
            $(this).toggleClass("on");
            var direction = $(this).attr('data-sort-direction');
            /* convert it to a boolean */
            var isAscending = (direction === 'desc');
            var newDirection = (isAscending) ? 'asc' : 'desc';
            /* pass it to isotope */
            $NewsGrid.isotope({
                sortBy: sortValue,
                sortAscending: isAscending
            });
            $(this).attr('data-sort-direction', newDirection);
        });
    }
});
var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    // Fixed Menu
    if (scroll >= stickyOffset) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }
    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } else {
        $('.goto-top').removeClass('visible');
    }
    // code for circular-counter 
    if ($('.circular-progressbar').length) {
        var count_flow = $('.circular-progressbar').offset().top - win_height();
        if (scroll > count_flow) {
            $('.circular-progressbar').each(function () {
                circle_progress_bar(this);
            });
        }
    }
    // code for counter 
    if ($('.counter-blocks').length) {
        var count_scroll = $('.counter-blocks').offset().top - win_height();
        if (scroll > count_scroll) {
            $('.animation-counter').each(function () {
                init_odometer(this);
            });
        }
    }
    // code for counter 
    if ($('.employee-counter-teaser').length) {
        var count_scroll = $('.employee-counter-teaser').offset().top - win_height();
        if (scroll > count_scroll) {
            $('.animation-counter').each(function () {
                init_odometer(this);
            });
        }
    }
    //circular progress-bar counter
    if ($(".video-teaser").length) {
        var count_scroll = $(".video-teaser").offset().top - win_height();
        if (scroll > count_scroll) {
            counter_block();
        }
    }
});
var DELAY = 500,
    clicks = 0,
    timer = null;

function isTouchDevice() {
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
$(document).on("click", ".has-sub-menu > a", function (e) {
    if (isTouchDevice() === true && (window.matchMedia('(min-width: 993px)').matches) && (window.matchMedia('(max-width: 1200px)').matches)) {
        clicks++;
        if (clicks === 1) {
            timer = setTimeout(function () {
                clicks = 0;
            }, DELAY);
            e.preventDefault();
        } else {
            clearTimeout(timer);
            clicks = 0;
        }
    }
}).on("dblclick", function (e) { });
function nav_height() {
    if (window.matchMedia('(min-width: 991px)').matches) {
        $('.navigation').css('min-height', 'auto');
        $('.navigation').css('margin-top', 0);
    } else {
        $('.navigation').css('min-height', win_height() - header_height() + 1);
        $('.navigation').css('margin-top', header_height() - 1);
    }
}
function win_height() {
    return $(window).outerHeight();
}
function win_width() {
    return $(window).width();
}
function header_height() {
    return $('header.page').outerHeight();
}
/*Odometer Function*/
function init_odometer(el) {
    if ($(".animation-counter-odometer", el).length == 0) return;
    var odometer = $(".animation-counter-odometer", el).get(0);
    var format = $(el).closest(".animation-counter-box").data("number-format");
    format = format ? format : "(ddd).ddd";
    var od = new Odometer({
        el: odometer,
        value: $(odometer).text(),
        format: format
    });
    od.update($(odometer).data("to"));

    window.thegem_init_odometer = init_odometer;
    $(".animation-counter-odometer").each(function(index) {
        init_odometer(this);
    });
}
//circular progress-bar counter
function circle_progress_bar(el) {
    // Circular progressbar
    var ProgressBarValue = $(el).attr('data-counter-value');
    $(el).find('.circle').attr('stroke-dasharray', ProgressBarValue);
}
function counter_block() {
    $(".count").each(function () {
        var $this = $(this),
            countTo = $this.attr("data-count");
        $({ countNum: $this.text() }).animate(
            {
                countNum: countTo
            },
            {
                duration: 2000,
                easing: "linear",
                step: function () {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function () {
                    $this.text(this.countNum);
                }
            }
        );
    });
}
/*isotope_masonry Function*/
function isotope_masonry() {
    //portfolio Isotope plugins initialize
    if ($('.news-grid').length) {
        $NewsGrid = $('.news-grid').isotope({
            itemSelector: '.news-grid-item',
            layoutMode: "packery",
            getSortData: {
                dateby: '.news-date',
                filename: '.news-title',
            }
        });
        var $img = $('img');
        $NewsGrid.imagesLoaded(function () {
            $img.on('load', function () {
                $NewsGrid.isotope('layout');
            });
        });

        // filter items on button click
        $('.js-filter').on('click', 'button', function () {
            var filterValue = $(this).attr('data-filter');
            $NewsGrid.isotope({
                filter: filterValue
            });
            $('.js-filter button').removeClass('is-active');
            $(this).addClass('is-active');
        });
    }
}
/* Preloader */
function remove_loader() {
    $('.preloader').hide();
}
function landing_section_height() {
    if (window.matchMedia('(min-width: 993px)').matches) {
        $('.landing-slider-init').css('height', win_height());
    }
}
function msie_version() {
    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident/.test(ua);
    if (isIE) {
        $('body').addClass('msie');
    }
}
